import { FaFlag, FaRegFlag } from "react-icons/fa";
import StatusChip from "../../components/StatusChip/StatusChip";
import { LESSON_STATUS } from "../LessonPlanner/LessonPlannerConstant";
import { formatDate } from "../LessonPlanner/utils/lessonPlanUtils";

const getExecution = (lesson) => {
  if (lesson.isFlagged) return { label: "Flagged", tone: "danger" };
  if (lesson.status === LESSON_STATUS.COMPLETED) return { label: "Completed", tone: "success" };
  return { label: "Pending", tone: "warning" };
};

/**
 * Lesson rows of a weekly diary (lessons sorted by date).
 * Used by the reviewer's diary page and the teacher's Weekly Update popup.
 * @param {Object[]} lessons
 */
export const diaryLessonTableConstants = (lessons) => [
  {
    title: "Date",
    // Show the date only on the first lesson of each day, like a diary
    render: (lesson) => {
      const index = lessons.indexOf(lesson);
      const isFirstOfDay = index <= 0 || lessons[index - 1].lessonDate !== lesson.lessonDate;
      return <span className="fw-semibold">{isFirstOfDay ? formatDate(lesson.lessonDate, "EEE, do MMM''yy") : ""}</span>;
    },
  },
  {
    title: "Period",
    render: (lesson) => <span className="lp-text-primary">{lesson.period ? `P${lesson.period}` : "—"}</span>,
  },
  {
    title: "Class",
    render: (lesson) => <span className="fw-semibold">{lesson.programName}</span>,
  },
  {
    title: "Subject",
    render: (lesson) => lesson.subjectName || "—",
  },
  {
    title: "Execution",
    render: (lesson) => {
      const execution = getExecution(lesson);
      return <StatusChip tone={execution.tone}>{execution.label}</StatusChip>;
    },
  },
  {
    title: "Flag",
    render: (lesson) =>
      lesson.isFlagged ? <FaFlag className="text-danger" /> : <FaRegFlag className="text-muted" />,
  },
  {
    title: "Teacher's Reflection",
    render: (lesson) => <span className="lp-reflection">{lesson.reflection || lesson.remark || "—"}</span>,
  },
];
